var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9992 3.67912C17.4926 3.67912 17.0781 3.26521 17.0781 2.75934V0.919779C17.0781 0.4139 17.4926 0 17.9992 0C18.5058 0 18.9202 0.4139 18.9202 0.919779V2.75934C18.9202 3.26521 18.5058 3.67912 17.9992 3.67912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5763 25.5702C32.4612 25.5702 32.323 25.5472 32.2079 25.5012L30.527 24.7654C30.0665 24.5585 29.8362 24.0296 30.0434 23.5467C30.2507 23.0868 30.7803 22.8569 31.2638 23.0638L32.9448 23.7997C33.4053 24.0066 33.6355 24.5355 33.4283 25.0184C33.2901 25.3633 32.9448 25.5702 32.5763 25.5702Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7365 15.6364H34.5786C35.0852 15.6364 35.4996 15.2225 35.4996 14.7167C35.4996 14.2108 35.0852 13.7969 34.5786 13.7969H32.7365C32.2299 13.7969 31.8154 14.2108 31.8154 14.7167C31.8154 15.2225 32.2299 15.6364 32.7365 15.6364Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.131 7.35829C27.9008 7.35829 27.6705 7.26632 27.4863 7.08236C27.1179 6.71445 27.1179 6.13959 27.4863 5.77168L28.7988 4.46099C29.1672 4.09308 29.7429 4.09308 30.1113 4.46099C30.4797 4.8289 30.4797 5.40377 30.1113 5.77168L28.7988 7.08236C28.5915 7.26632 28.3613 7.35829 28.131 7.35829Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22358 7.08236C7.40779 7.26632 7.63805 7.35829 7.86832 7.35829C8.09858 7.35829 8.32884 7.26632 8.53608 7.08236C8.9045 6.71445 8.9045 6.13959 8.53608 5.77168L7.22358 4.46099C6.85516 4.09308 6.2795 4.09308 5.91108 4.46099C5.54266 4.8289 5.54266 5.40377 5.91108 5.77168L7.22358 7.08236Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26316 15.6362H1.42105C0.914474 15.6362 0.5 15.2223 0.5 14.7165C0.5 14.2106 0.914474 13.7967 1.42105 13.7967H3.26316C3.76974 13.7967 4.18421 14.2106 4.18421 14.7165C4.18421 15.2223 3.76974 15.6362 3.26316 15.6362Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57273 25.0179C2.73392 25.3628 3.07931 25.5697 3.42471 25.5697C3.53984 25.5697 3.65497 25.5468 3.79313 25.5008L5.47405 24.7649C5.93457 24.558 6.16484 24.0061 5.9576 23.5462C5.75036 23.0863 5.19773 22.8564 4.73721 23.0633L3.05628 23.7992C2.59576 24.0061 2.3655 24.558 2.57273 25.0179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarLine);
export default __webpack_public_path__ + "static/media/icon-star-line.be4be16c4eb794557e834d65c103e98b.svg";
export { ForwardRef as ReactComponent };